document.addEventListener('DOMContentLoaded', () => {
  const faqBlock = document.querySelector<HTMLDivElement>('.faq-block');
  const searchForm = document.querySelector<HTMLFormElement>(
    'form[role="search"]',
  );
  const searchInput =
    searchForm?.querySelector<HTMLInputElement>('input[type="text"]');

  if (!faqBlock || !searchForm || !searchInput) return;

  function updateMargins(items: NodeListOf<Element>) {
    const visible = Array.from(items).filter(
      (el) =>
        (el.querySelector('.faq-content') as HTMLElement).dataset.visible ===
        'true',
    );
    visible.forEach((el, i) => {
      (el as HTMLElement).style.marginBottom =
        i === visible.length - 1 ? '0px' : '16px';
    });
  }

  function setItemVisibility(el: Element, visible: boolean) {
    const content = el.querySelector<HTMLElement>('.faq-content');
    if (!content) return;

    if (visible) {
      content.style.height = `${content.offsetHeight}px`;
      requestAnimationFrame(() => {
        content.style.height = `${content.scrollHeight}px`;
        content.dataset.visible = 'true';
      });

      const handler = () => {
        if (content.dataset.visible === 'true') content.style.height = 'auto';
        content.removeEventListener('transitionend', handler);
      };
      content.addEventListener('transitionend', handler);
    } else {
      if (content.style.height === 'auto')
        content.style.height = `${content.scrollHeight}px`;
      requestAnimationFrame(() => {
        content.style.height = '0px';
        content.dataset.visible = 'false';
      });
    }
  }

  function initToggle() {
    document
      .querySelectorAll<HTMLButtonElement>('.toggle-faq')
      .forEach((btn) => {
        btn.addEventListener('click', () => {
          const parent = btn.closest('.faq-subcat');
          if (!parent) return;

          const items = parent.querySelectorAll('.faq-item');
          Array.from(items)
            .slice(4)
            .forEach((el) => {
              const content = el.querySelector<HTMLElement>('.faq-content');
              if (!content) return;
              setItemVisibility(el, content.dataset.visible !== 'true');
              content.addEventListener(
                'transitionend',
                () => updateMargins(items),
                { once: true },
              );
            });

          const svg = btn.querySelector('svg');
          if (svg) svg.classList.toggle('-rotate-90');
        });
      });
  }

  function initFAQ() {
    document.querySelectorAll('.faq-subcat').forEach((subcat) => {
      const items = subcat.querySelectorAll('.faq-item');
      items.forEach((el, i) => setItemVisibility(el, i < 4));
      requestAnimationFrame(() => updateMargins(items));
    });
    initToggle();
  }

  initFAQ();

  function fetchFAQs(query: string = '') {
    const data = new FormData();
    data.append('action', 'filter_faqs');
    data.append('term_id', faqBlock.dataset.termId ?? '');
    if (query !== '') data.append('search', query);

    fetch(window.wpAjaxUrl, {
      method: 'POST',
      body: data,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(res.data, 'text/html');
          const hasFaqItems = doc.querySelectorAll('.faq-item').length > 0;

          if (hasFaqItems) {
            faqBlock.innerHTML = res.data;
            initFAQ();

            requestAnimationFrame(() => {
              window.scrollTo({
                top:
                  faqBlock.getBoundingClientRect().top + window.scrollY - 100,
                behavior: 'smooth',
              });
            });
          } else {
            faqBlock.innerHTML = `
              <div class="no-results flex flex-row items-center gap-6">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.8 32.2C16.0333 32.4667 16.2917 32.6 16.575 32.6C16.8583 32.6 17.1333 32.4667 17.4 32.2L24 25.6L30.65 32.25C30.8833 32.4833 31.15 32.5917 31.45 32.575C31.75 32.5583 32 32.4333 32.2 32.2C32.4667 31.9667 32.6 31.7083 32.6 31.425C32.6 31.1417 32.4667 30.8667 32.2 30.6L25.6 24L32.25 17.35C32.4833 17.1167 32.5917 16.85 32.575 16.55C32.5583 16.25 32.4333 16 32.2 15.8C31.9667 15.5333 31.7083 15.4 31.425 15.4C31.1417 15.4 30.8667 15.5333 30.6 15.8L24 22.4L17.35 15.75C17.1167 15.5167 16.85 15.4083 16.55 15.425C16.25 15.4417 16 15.5667 15.8 15.8C15.5333 16.0333 15.4 16.2917 15.4 16.575C15.4 16.8583 15.5333 17.1333 15.8 17.4L22.4 24L15.75 30.65C15.5167 30.8833 15.4083 31.15 15.425 31.45C15.4417 31.75 15.5667 32 15.8 32.2ZM24 43C21.3333 43 18.8417 42.5167 16.525 41.55C14.2083 40.5833 12.1917 39.2417 10.475 37.525C8.75833 35.8083 7.41667 33.7917 6.45 31.475C5.48333 29.1583 5 26.6667 5 24C5 21.3333 5.48333 18.85 6.45 16.55C7.41667 14.25 8.75833 12.2417 10.475 10.525C12.1917 8.80833 14.2083 7.45833 16.525 6.475C18.8417 5.49167 21.3333 5 24 5C26.6667 5 29.15 5.49167 31.45 6.475C33.75 7.45833 35.7583 8.80833 37.475 10.525C39.1917 12.2417 40.5417 14.25 41.525 16.55C42.5083 18.85 43 21.3333 43 24C43 26.6667 42.5083 29.1583 41.525 31.475C40.5417 33.7917 39.1917 35.8083 37.475 37.525C35.7583 39.2417 33.75 40.5833 31.45 41.55C29.15 42.5167 26.6667 43 24 43ZM24 40.75C28.6 40.75 32.5417 39.1083 35.825 35.825C39.1083 32.5417 40.75 28.6 40.75 24C40.75 19.4 39.1083 15.4583 35.825 12.175C32.5417 8.89167 28.6 7.25 24 7.25C19.4 7.25 15.4583 8.89167 12.175 12.175C8.89167 15.4583 7.25 19.4 7.25 24C7.25 28.6 8.89167 32.5417 12.175 35.825C15.4583 39.1083 19.4 40.75 24 40.75Z" fill="#F6B696"/>
                </svg>
                <p class="text-h3-light text-primary-white-90">
                  Žiadne výsledky vyhľadávania.
                </p>
              </div>
            `;
            requestAnimationFrame(() => {
              window.scrollTo({
                top:
                  faqBlock.getBoundingClientRect().top + window.scrollY - 100,
                behavior: 'smooth',
              });
            });
          }
        }
      });
  }

  searchForm.addEventListener('submit', (e) => {
    e.preventDefault();
    fetchFAQs(searchInput.value.trim());
  });

  searchInput.addEventListener('input', () => {
    if (searchInput.value.trim() === '') fetchFAQs();
  });
});
